import { useMutationStatus } from "../../hooks/useMutationStatus";
import { Headline as Control } from "./Headline";
import { HeadlineSkeleton } from "./HeadlineSkeleton";
import type { HeadlineProps } from "./types";

export const Headline = (props: HeadlineProps) => {
  const isToggling = useMutationStatus("toggleCovers");

  if (isToggling) {
    return <HeadlineSkeleton {...props} />;
  }
  return <Control {...props} />;
};

export * from "./types";
